







































import { ciAngleDown } from '~/icons/source/regular/angle-down'
import {
  defineNuxtComponent,
  PropType,
  ref,
  vue3Model,
  watch
} from '~/utils/nuxt3-migration'

export default defineNuxtComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      default: 'md'
    },
    withoutIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonClass: {
      type: String,
      default: null
    },
    contentClass: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const isExpanded = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newValue: boolean) => {
        isExpanded.value = newValue
      }
    )

    // This is explicitly for parent usage
    function expand() {
      isExpanded.value = true
      emit('update:modelValue', isExpanded.value)
    }
    function handleTriggerClick() {
      if (props.disabled) {
        return false
      }
      isExpanded.value = !isExpanded.value
      emit('update:modelValue', isExpanded.value)
    }
    function enter(element: HTMLElement) {
      const height = element.scrollHeight
      element.style.height = '0px'
      requestAnimationFrame(() => {
        element.style.height = `${height}px`
      })
    }
    function leave(element: HTMLElement) {
      const height = element.scrollHeight
      element.style.height = `${height}px`
      requestAnimationFrame(() => {
        element.style.height = '0px'
      })
    }
    function afterEnter(element: HTMLElement) {
      element.style.height = 'auto'
    }

    return {
      ciAngleDown,
      isExpanded,
      expand,
      handleTriggerClick,
      enter,
      leave,
      afterEnter
    }
  }
})
